import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/axelerate-logo-purple.svg'
import _imports_1 from '@/assets/ilustration-forgot.svg'
import _imports_2 from '@/assets/icons/back-arrow-primary.svg'
import _imports_3 from '@/assets/ilustration-sent.svg'


const _hoisted_1 = { class: "bg-background min-h-screen" }
const _hoisted_2 = { class: "flex justify-center items-center min-h-screen" }
const _hoisted_3 = { class: "flex flex-col bg-white shadow rounded-2xl w-1/2 xl:w-1/3 p-14" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "w-2/5"
}, null, -1)
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "flex flex-col pt-10" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "w-1/2"
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "text-2xl font-semibold pt-10" }, "Forgot your password?", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "pt-4" }, "We will send you the instructions to recover your account", -1)
const _hoisted_10 = {
  key: 0,
  class: "text-red-500 mt-4"
}
const _hoisted_11 = {
  key: 1,
  class: "text-red-500 mt-4"
}
const _hoisted_12 = { class: "flex mt-10" }
const _hoisted_13 = { class: "flex flex-row justify-center" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row mt-10" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }),
  /*#__PURE__*/_createElementVNode("span", { class: "pl-4" }, "Back to login")
], -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "flex flex-col pt-10" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  class: "w-1/2"
}, null, -1)
const _hoisted_19 = { class: "flex flex-col" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "text-2xl font-semibold pt-10" }, "Email sent", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "pt-4" }, "Don't forget to check your inbox or spam folder.", -1)
const _hoisted_22 = { class: "flex pt-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (!_ctx.emailSent)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _hoisted_8,
                _hoisted_9,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
                  type: "text",
                  class: "apperance-none border-0 rounded bg-gray-100 p-4 mt-10 focus:bg-white focus:outline-none focus:ring-2 focus:ring-black",
                  placeholder: "Email"
                }, null, 512), [
                  [_vModelText, _ctx.email]
                ]),
                (_ctx.errors.validation)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, " Must enter a valid email. "))
                  : _createCommentVNode("", true),
                (_ctx.errors.api)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, " Something wen wrong, please try again. "))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("button", {
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.sendEmail && _ctx.sendEmail(...args))),
                    class: "w-full text-white bg-primary rounded-full py-4"
                  }, " Reset your password ")
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/login'))),
                  class: "text-primary font-medium pl-2"
                }, _hoisted_15)
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _hoisted_21,
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("button", {
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push('/login'))),
                      class: "w-full text-white bg-primary rounded-full py-4"
                    }, " Got it ")
                  ])
                ])
              ])
            ]))
      ])
    ])
  ]))
}